import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { Link } from "../../ui/Link";
import Image from "next/image";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { barlowCondensed } from "../../../utils/fonts";
import { Button } from "../../ui/Button";
import type { Route } from "next";
import type { Offer } from "@local/offer/src/types";
import type { SweepstakesState } from "@local/offer/src/lib/const/sweepstakes";
import { EntriesBadge } from "@local/offer/src/components/sweepstakes/EntriesBadge";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { buy } from "@local/i18n/src/catalogs/buy";
import { DiscountPrice } from "./DiscountPrice";
export interface BestSellersSingleBlockProps {
  product: Offer.BlockListing;
  index: number;
  isVisible: boolean;
  /** Mobile card style <md, vertical (desktop side-column) style from md up. */
  responsive?: boolean;
  market?: string;
  /**
   * Scheduled campaign state, resolved on the server. Passed in so SSR and
   * hydration render the same state; the client re-resolves it after mount.
   */
  sweepstakesState?: SweepstakesState;
}
export const BestSellersSingleBlock = t0 => {
  const $ = _c(83);
  const {
    product,
    index,
    isVisible,
    responsive,
    market,
    sweepstakesState
  } = t0;
  const productUrl = `/${market}/product/${product.slug}`;
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== index || $[1] !== isVisible || $[2] !== market || $[3] !== product.image?.filename || $[4] !== product.image?.height || $[5] !== product.image?.url || $[6] !== product.image?.width || $[7] !== product.name || $[8] !== product.prices || $[9] !== productUrl || $[10] !== responsive || $[11] !== sweepstakesState) {
    const t = getT(getLanguageForMarket(market), {
      buy
    });
    const t14 = index > 2 && !isVisible ? "hidden md:block" : "";
    const t15 = responsive ? "rounded-md shadow-md md:rounded-none md:shadow-none" : "rounded-md shadow-md";
    if ($[26] !== t14 || $[27] !== t15) {
      t13 = cn("group relative h-full w-full", t14, t15);
      $[26] = t14;
      $[27] = t15;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    t11 = "flex h-full w-full flex-col justify-start md:justify-between";
    const t16 = responsive ? "aspect-video md:aspect-square" : "aspect-video";
    let t17;
    if ($[29] !== t16) {
      t17 = cn("relative mb-1 w-full overflow-hidden bg-gray-100", t16);
      $[29] = t16;
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    const t18 = product.image?.url as string;
    const t19 = product.image?.width || 640;
    let t20;
    if ($[31] !== t18 || $[32] !== t19) {
      t20 = getCdnUrl({
        src: t18,
        width: t19
      });
      $[31] = t18;
      $[32] = t19;
      $[33] = t20;
    } else {
      t20 = $[33];
    }
    const t21 = product.image?.filename as string;
    const t22 = product.image?.width || 640;
    const t23 = product.image?.height || 640;
    let t24;
    if ($[34] !== t20 || $[35] !== t21 || $[36] !== t22 || $[37] !== t23) {
      t24 = <Image src={t20} alt={t21} width={t22} height={t23} sizes="960px" className="h-full w-full object-cover object-top transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none" />;
      $[34] = t20;
      $[35] = t21;
      $[36] = t22;
      $[37] = t23;
      $[38] = t24;
    } else {
      t24 = $[38];
    }
    let t25;
    if ($[39] !== market || $[40] !== product.prices?.[0]?.discountValue || $[41] !== product.prices?.[0]?.value || $[42] !== sweepstakesState) {
      t25 = market && sweepstakesState && <EntriesBadge market={market} priceInMinorUnits={product.prices?.[0]?.discountValue ?? product.prices?.[0]?.value ?? 0} scheduled={sweepstakesState} className="absolute right-0 bottom-0 left-0" />;
      $[39] = market;
      $[40] = product.prices?.[0]?.discountValue;
      $[41] = product.prices?.[0]?.value;
      $[42] = sweepstakesState;
      $[43] = t25;
    } else {
      t25 = $[43];
    }
    if ($[44] !== t17 || $[45] !== t24 || $[46] !== t25) {
      t12 = <div className={t17}>{t24}{t25}</div>;
      $[44] = t17;
      $[45] = t24;
      $[46] = t25;
      $[47] = t12;
    } else {
      t12 = $[47];
    }
    const t26 = responsive ? "px-6 md:px-0" : "px-6";
    if ($[48] !== t26) {
      t8 = cn(t26, "flex flex-1 flex-col justify-between");
      $[48] = t26;
      $[49] = t8;
    } else {
      t8 = $[49];
    }
    const t27 = responsive ? "" : "text-xl md:text-3xl";
    let t28;
    if ($[50] !== t27) {
      t28 = cn(barlowCondensed.className, "rounded-sm text-xl font-semibold uppercase hover:underline focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:outline-hidden", t27);
      $[50] = t27;
      $[51] = t28;
    } else {
      t28 = $[51];
    }
    let t29;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = <span className="absolute inset-0" aria-hidden="true" />;
      $[52] = t29;
    } else {
      t29 = $[52];
    }
    if ($[53] !== product.name || $[54] !== productUrl || $[55] !== t28) {
      t9 = <h3><Link href={productUrl} className={t28} prefetch={false}>{t29}{product.name}</Link></h3>;
      $[53] = product.name;
      $[54] = productUrl;
      $[55] = t28;
      $[56] = t9;
    } else {
      t9 = $[56];
    }
    if ($[57] !== market || $[58] !== product.prices) {
      t10 = product.prices?.[0] && <DiscountPrice price={product.prices[0]} className="text-sm" market={market} />;
      $[57] = market;
      $[58] = product.prices;
      $[59] = t10;
    } else {
      t10 = $[59];
    }
    T0 = Button;
    t1 = "link";
    t2 = productUrl as Route;
    t3 = false;
    t4 = "true";
    t5 = -1;
    const t30 = responsive ? "my-4 md:my-0 md:mt-2" : "my-4";
    if ($[60] !== t30) {
      t6 = cn("z-raised relative w-full! max-w-full text-lg font-medium uppercase md:font-normal", t30);
      $[60] = t30;
      $[61] = t6;
    } else {
      t6 = $[61];
    }
    t7 = t("buy.shopNow");
    $[0] = index;
    $[1] = isVisible;
    $[2] = market;
    $[3] = product.image?.filename;
    $[4] = product.image?.height;
    $[5] = product.image?.url;
    $[6] = product.image?.width;
    $[7] = product.name;
    $[8] = product.prices;
    $[9] = productUrl;
    $[10] = responsive;
    $[11] = sweepstakesState;
    $[12] = T0;
    $[13] = t1;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[12];
    t1 = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t2 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t14;
  if ($[62] !== T0 || $[63] !== t1 || $[64] !== t2 || $[65] !== t3 || $[66] !== t4 || $[67] !== t5 || $[68] !== t6 || $[69] !== t7) {
    t14 = <T0 as={t1} href={t2} prefetch={t3} aria-hidden={t4} tabIndex={t5} className={t6}>{t7}</T0>;
    $[62] = T0;
    $[63] = t1;
    $[64] = t2;
    $[65] = t3;
    $[66] = t4;
    $[67] = t5;
    $[68] = t6;
    $[69] = t7;
    $[70] = t14;
  } else {
    t14 = $[70];
  }
  let t15;
  if ($[71] !== t10 || $[72] !== t14 || $[73] !== t8 || $[74] !== t9) {
    t15 = <div className={t8}>{t9}{t10}{t14}</div>;
    $[71] = t10;
    $[72] = t14;
    $[73] = t8;
    $[74] = t9;
    $[75] = t15;
  } else {
    t15 = $[75];
  }
  let t16;
  if ($[76] !== t11 || $[77] !== t12 || $[78] !== t15) {
    t16 = <div className={t11}>{t12}{t15}</div>;
    $[76] = t11;
    $[77] = t12;
    $[78] = t15;
    $[79] = t16;
  } else {
    t16 = $[79];
  }
  let t17;
  if ($[80] !== t13 || $[81] !== t16) {
    t17 = <article className={t13}>{t16}</article>;
    $[80] = t13;
    $[81] = t16;
    $[82] = t17;
  } else {
    t17 = $[82];
  }
  return t17;
};